import React from 'react';

const MainMenu = ({ onSelectGame }) => {
  const gamesList = [
    { id: 'auditGuessing', title: 'Risk Wheel' },
    { id: 'auditMemory', title: 'Internal Control Memory' },
    { id: 'shooting', title: 'Hit the Dollar' },
    { id: 'catchFraudster', title: 'Find the Hidden Cash' },


  ];


  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4">
      <h1 className="text-3xl font-bold mb-6">Game Dashboard</h1>
      <p className="mb-4">Select a game to play:</p>
      <ul className="w-full max-w-sm space-y-4">
        {gamesList.map((game) => (
          <li key={game.id}>
            <button 
              onClick={() => onSelectGame(game.id)}
              className="w-full bg-blue-500 text-white px-4 py-3 rounded hover:bg-blue-600 transition"
            >
              {game.title}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MainMenu;
